import CoinflipImg from '@assets/png/coinflip-illustration.png';
import JackpotImg from '@assets/png/jackpot-illustration.png';
// import BlackjackImg from '@assets/png/blackjack-illustration.png';
import GameCard from './game-card';
import useGamesActivePlayers from '@hooks/useGamesActivePlayers';
import styles from './duelana-games.module.scss';

const DuelanaGames = (): JSX.Element => {
    const {
        // blackjackActivePlayers,
        coinflipActivePlayers,
        jackpotActivePlayers,
    } = useGamesActivePlayers({
        fetch: { blackjack: true, coinflip: true, jackpot: true },
    });

    return (
        <section className={styles.games}>
            <h2>Duelana Games</h2>

            <div className={styles.games__list}>
                <GameCard
                    activePlayers={coinflipActivePlayers}
                    picture={CoinflipImg}
                    title="Coin Flip"
                    to="/games/coinflip"
                    className={styles.games__coinflip}
                />
                <GameCard
                    activePlayers={jackpotActivePlayers}
                    picture={JackpotImg}
                    title="Jackpot"
                    to="/games/jackpot"
                    className={styles.games__jackpot}
                />
                {/* <GameCard
                    activePlayers={blackjackActivePlayers}
                    picture={BlackjackImg}
                    title="Blackjack"
                    to="/games/blackjack"
                    className={styles.games__blackjack}
                /> */}
            </div>
        </section>
    );
};

export default DuelanaGames;
